export const categories = [
  {
    id: "all",
    name: "全部案例",
    slug: "all",
    description: "浏览糖心传媒所有品牌营销案例与行业洞察",
  },
  {
    id: "short-video",
    name: "短视频制作",
    slug: "short-video",
    description: "高质量短视频内容创作，涵盖品牌故事、产品展示、创意广告等多元形式",
  },
  {
    id: "social-media",
    name: "社交媒体运营",
    slug: "social-media",
    description: "多平台社交媒体策略运营，提升品牌声量与用户互动",
  },
  {
    id: "kol",
    name: "KOL合作",
    slug: "kol",
    description: "精准匹配头部及垂类KOL资源，实现高效种草与转化",
  },
  {
    id: "full-case",
    name: "全案策划",
    slug: "full-case",
    description: "从策略到执行的一站式品牌全案营销解决方案",
  },
  {
    id: "insight",
    name: "行业洞察",
    slug: "insight",
    description: "深度行业研究报告与数字营销趋势分析",
  },
];

export const articles = [
  {
    id: "article-1",
    title: "新消费品牌如何通过短视频实现月销千万增长",
    slug: "new-consumer-brand-short-video-growth",
    category: "short-video",
    categoryName: "短视频制作",
    excerpt:
      "深度解析某新锐消费品牌在抖音、快手两大平台的内容策略，通过精准人群定向与创意内容矩阵，3个月内实现GMV从百万到千万的跨越式增长。",
    content: `在新消费浪潮席卷的当下，短视频已成为品牌与消费者建立情感连接的核心渠道。糖心传媒团队近期为某新锐护肤品牌打造了一套完整的短视频内容策略，帮助其在竞争激烈的美妆赛道中脱颖而出。

## 策略洞察

品牌面临的核心挑战是：产品力足够，但品牌声量不足。传统投放成本高企，ROI持续走低。我们通过对目标用户的深度画像分析，发现18-35岁女性用户在短视频平台的消费决策路径存在明显的「种草-搜索-比价-下单」四阶段模型。

## 内容矩阵搭建

我们为该品牌设计了「3+2+1」内容矩阵：
- 3条品牌故事线：创始人IP打造、产品研发幕后、用户体验纪实
- 2条产品种草线：场景化使用教程、成分科普对比
- 1条热点借势线：紧跟平台热点话题，快速产出关联内容

## 执行数据

三个月执行周期内，累计产出短视频内容186条，总播放量突破2.3亿次，品牌搜索指数提升340%，抖音小店GMV从月均120万增长至峰值1,850万。

## 关键成功要素

内容质量是基础，但更关键的是我们建立的数据反馈闭环。每条视频发布后2小时、6小时、24小时三个节点进行数据复盘，及时调整内容方向和投放策略。这种敏捷迭代的模式，让品牌在快速变化的流量环境中始终保持竞争力。`,
    coverImage:
      "https://readdy.ai/api/search-image?query=Modern%20creative%20studio%20workspace%20with%20professional%20video%20production%20equipment%2C%20warm%20ambient%20lighting%2C%20clean%20minimalist%20aesthetic%2C%20soft%20natural%20tones%2C%20editorial%20photography%20with%20shallow%20depth%20of%20field%2C%20professional%20atmosphere&width=800&height=450&seq=article-cover-01&orientation=landscape",
    date: "2026-07-28",
    readTime: "8分钟",
    tags: ["短视频", "品牌增长", "抖音", "内容策略"],
    featured: true,
  },
  {
    id: "article-2",
    title: "从0到百万粉丝：社交媒体矩阵运营实战拆解",
    slug: "social-media-matrix-million-followers",
    category: "social-media",
    categoryName: "社交媒体运营",
    excerpt:
      "糖心传媒为某家居品牌搭建的跨平台社交媒体矩阵，通过精细化内容运营与用户社群建设，一年内实现全平台粉丝突破百万。",
    content: `社交媒体运营早已不是简单的「发内容、买粉丝」时代。在信息过载的当下，如何让品牌内容在海量信息中被看见、被记住、被传播，是每个品牌营销人必须回答的核心命题。

## 矩阵策略设计

我们为该家居品牌制定的策略核心是「一核多翼」：
- 核心阵地小红书：承载品牌调性塑造与深度种草功能
- 微信生态：私域流量沉淀与用户长期价值挖掘
- 抖音：品牌声量放大与增量用户获取
- 微博：热点话题参与与品牌人格化塑造

## 内容运营体系

不同平台的内容策略需要差异化设计。小红书侧重高质量图文与真实体验分享，抖音强调视觉冲击与情绪价值，微信注重深度内容与服务闭环，微博则突出实时互动与话题参与。

我们为该品牌建立了「中央厨房+地方分发」的内容生产模式：由品牌内容中心统一策划主题与视觉规范，各平台运营团队根据平台特性进行二次创作与适配。

## 成果回顾

一年执行周期内：
- 小红书粉丝从3,200增长至42万
- 微信公众号粉丝突破28万
- 抖音账号累计获赞1,500万+
- 品牌全平台月均互动量超过50万次
- 来自社交媒体的直接销售额占比从8%提升至35%

## 核心方法论

社交媒体运营的本质不是追求流量数字，而是构建品牌与用户之间的信任关系。我们始终坚持「70%价值内容+20%互动内容+10%转化内容」的内容配比原则，确保用户在每一个触达点都能获得真实价值。`,
    coverImage:
      "https://readdy.ai/api/search-image?query=Modern%20office%20team%20brainstorming%20around%20digital%20screens%20showing%20social%20media%20analytics%2C%20warm%20lighting%2C%20creative%20atmosphere%2C%20collaborative%20workspace%2C%20professional%20yet%20relaxed%20vibe&width=800&height=450&seq=article-cover-02&orientation=landscape",
    date: "2026-07-15",
    readTime: "10分钟",
    tags: ["社交媒体", "矩阵运营", "小红书", "粉丝增长"],
    featured: true,
  },
  {
    id: "article-3",
    title: "KOL营销3.0：从单次投放到深度共创的合作模式升级",
    slug: "kol-marketing-3-co-creation-model",
    category: "kol",
    categoryName: "KOL合作",
    excerpt:
      "糖心传媒首创的「品牌×KOL深度共创」模式，帮助多个品牌实现种草内容的高效转化，ROI较传统投放模式提升200%以上。",
    content: `KOL营销正在经历从1.0到3.0的范式转移。1.0时代是简单的曝光购买，2.0时代是数据驱动的精准匹配，而3.0时代的核心是品牌与KOL的深度价值共创。

## 行业痛点

传统KOL投放面临三大核心问题：
1. 内容同质化：KOL为多个品牌生产类似内容，用户审美疲劳
2. 转化断层：种草内容与购买链路割裂，用户流失严重
3. 效果难衡量：以曝光量为核心的考核体系与品牌实际增长脱节

## 糖心方法论：深度共创模型

我们构建了一套完整的KOL深度共创体系，包含四个关键环节：

环节一：共创策略会
在合作启动前，品牌方、KOL、糖心策略团队三方共同参与策略研讨会。KOL基于对自身粉丝的深度理解提供内容方向建议，品牌方明确核心诉求与边界，糖心团队负责将双方输入转化为可执行的创意方案。

环节二：内容工坊
我们为每个合作项目设立专属内容工坊，由专业内容导演、编剧、摄影师与KOL配合，在保持KOL个人风格的前提下，提升内容的专业度和品牌调性。

环节三：数据共建
合作期间，品牌与KOL共享脱敏数据，共同分析内容表现与用户反馈，实时优化内容策略。这种透明化的数据协作模式大幅提升了双方的信任度与合作效率。

环节四：长效运营
单次合作结束后，我们帮助品牌与优质KOL建立长期合作关系，从「一次性投放」升级为「品牌挚友」模式，持续产出深度内容，积累品牌资产。

## 实战案例

为某运动品牌执行的KOL深度共创项目：
- 合作KOL数量：12位（覆盖健身、户外、潮流三大圈层）
- 内容产出：48条深度共创视频+96篇图文
- 总曝光量：1.8亿+
- 直接引导GMV：2,300万+
- 品牌NPS（净推荐值）提升22个百分点`,
    coverImage:
      "https://readdy.ai/api/search-image?query=Professional%20content%20creator%20filming%20with%20camera%20in%20modern%20studio%20setup%2C%20warm%20lighting%2C%20creative%20atmosphere%2C%20behind%20the%20scenes%20of%20influencer%20marketing%20production&width=800&height=450&seq=article-cover-03&orientation=landscape",
    date: "2026-06-28",
    readTime: "12分钟",
    tags: ["KOL营销", "内容共创", "ROI优化", "品牌合作"],
    featured: true,
  },
  {
    id: "article-4",
    title: "餐饮品牌全案策划：从区域小店到全国连锁的品牌升级之路",
    slug: "restaurant-brand-full-case-upgrade",
    category: "full-case",
    categoryName: "全案策划",
    excerpt:
      "糖心传媒为某区域餐饮品牌提供的品牌全案升级服务，涵盖品牌定位、视觉体系、内容策略与数字化营销，助力其完成从8家到120+门店的跨越。",
    content: `餐饮行业的品牌化竞争正在加速。依赖产品口味和地理位置的传统优势正在被品牌认知所取代。糖心传媒为某区域火锅品牌执行的品牌全案升级项目，完整呈现了从策略到执行的全链路服务能力。

## 项目背景

该品牌在成都拥有8家直营门店，口碑良好但品牌辨识度不足。面对全国性连锁品牌的竞争压力，品牌创始人希望通过系统性的品牌升级，为全国扩张奠定基础。

## 品牌策略

重新定义品牌内核
通过消费者深度访谈与竞品分析，我们提炼出品牌的核心差异化价值——「地道成都味，年轻社交场」。将品牌从传统的「老火锅」认知升级为「年轻人的品质火锅社交空间」。

视觉体系重塑
从LOGO、空间设计到线上视觉规范，全面升级品牌视觉识别系统。新的视觉语言融合了成都地域文化元素与现代极简美学，形成了独特的品牌视觉记忆点。

内容策略构建
围绕「火锅社交」这一核心概念，搭建了完整的内容生态：
- 品牌纪录片系列：讲述创始人故事与食材溯源
- 用户UGC激励计划：鼓励消费者分享火锅社交瞬间
- 节气营销日历：结合中国传统节气打造品牌内容IP

## 数字化营销落地

- 抖音本地生活运营：门店POI优化+达人探店矩阵
- 小红书种草策略：场景化内容+用户口碑沉淀
- 私域流量建设：企业微信+会员小程序打通线上线下

## 项目成果

品牌升级后12个月：
- 门店数量从8家扩张至120+家
- 品牌搜索指数同比增长580%
- 单店月均营收提升65%
- 会员复购率达到42%`,
    coverImage:
      "https://readdy.ai/api/search-image?query=Modern%20restaurant%20interior%20with%20warm%20ambient%20lighting%20and%20stylish%20design%2C%20elegant%20dining%20atmosphere%2C%20contemporary%20Asian%20aesthetic%2C%20professional%20architectural%20photography&width=800&height=450&seq=article-cover-04&orientation=landscape",
    date: "2026-06-10",
    readTime: "15分钟",
    tags: ["全案策划", "品牌升级", "餐饮", "连锁扩张"],
    featured: false,
  },
  {
    id: "article-5",
    title: "2026年数字营销趋势报告：AI驱动的内容变革时代",
    slug: "2026-digital-marketing-trends-ai-content",
    category: "insight",
    categoryName: "行业洞察",
    excerpt:
      "糖心传媒研究院发布2026年度数字营销趋势报告，深度分析AI技术对内容创作、用户触达与营销效率的重塑作用。",
    content: `2026年，数字营销行业正经历一场由AI技术驱动的深刻变革。糖心传媒研究院基于对500+品牌营销决策者的调研，结合平台数据与行业观察，发布本年度数字营销趋势报告。

## 趋势一：AI原生内容成为主流

AI辅助内容创作已从「尝鲜阶段」进入「标配阶段」。2026年，超过65%的品牌在内容生产流程中引入了AI工具。但值得关注的是，头部品牌正在从「AI辅助」向「AI原生」转变——不是用AI优化人类创作的内容，而是基于AI的能力边界重新设计内容策略。

## 趋势二：超个性化触达成新基准

随着用户数据维度的丰富与AI分析能力的提升，「千人千面」已不足以描述当前的个性化水平。领先品牌正在实践「一人千面」——根据同一用户在不同时间、场景、情绪状态下的需求变化，动态调整内容与产品推荐。

## 趋势三：短视频搜索化

短视频平台正在成为新一代搜索引擎。2026年Q1数据显示，抖音与快手的日均搜索量合计已超过传统搜索引擎的60%。品牌需要以「可被搜索到的短视频」为思路，重构内容策略。

## 趋势四：社区驱动的品牌增长

从「流量思维」到「社区思维」的转变正在加速。品牌私域社群、垂类社区、用户共创平台等社区形态的价值被重新评估。数据显示，社区活跃度高的品牌，用户LTV（生命周期价值）平均高出同业3.2倍。

## 趋势五：效果度量体系重构

以曝光和点击为核心的效果度量体系正在被挑战。新一代度量框架更加关注「注意力质量」与「心智份额」等深层指标。品牌需要建立涵盖短期转化与长期品牌资产的复合型度量体系。

## 给品牌营销人的建议

在快速变化的环境中，不变的是对用户价值的坚持。技术是工具，理解人性、创造真实价值才是品牌长青的根本。糖心传媒将持续关注行业前沿，为品牌提供专业的内容营销服务与策略支持。`,
    coverImage:
      "https://readdy.ai/api/search-image?query=Futuristic%20digital%20marketing%20analytics%20dashboard%20with%20data%20visualization%2C%20warm%20tech%20aesthetic%2C%20clean%20interface%20design%2C%20soft%20ambient%20lighting%2C%20modern%20office%20background&width=800&height=450&seq=article-cover-05&orientation=landscape",
    date: "2026-05-20",
    readTime: "18分钟",
    tags: ["行业趋势", "AI", "数字营销", "2026"],
    featured: false,
  },
  {
    id: "article-6",
    title: "美妆品牌的抖音短视频爆款公式拆解",
    slug: "beauty-brand-douyin-viral-formula",
    category: "short-video",
    categoryName: "短视频制作",
    excerpt:
      "复盘糖心传媒为某国货美妆品牌打造的抖音爆款内容体系，拆解从选题到制作再到投放的完整爆款公式。",
    content: `在抖音生态中，美妆赛道是竞争最激烈的垂类之一。如何在每天海量的内容中脱颖而出，是每个美妆品牌都在求解的难题。糖心传媒通过服务多个美妆品牌积累的方法论，总结出了一套可复用的爆款内容公式。

## 爆款公式：情绪钩子×信息密度×行动指令

我们将抖音爆款内容拆解为三个核心变量：

变量一：情绪钩子（前3秒）
前3秒决定了用户是否继续观看。我们总结了6大高转化钩子模型：
1. 反常识开篇：「99%的人都用错了粉底液」
2. 视觉冲击：「从素颜到全妆的15秒变身」
3. 悬念设置：「这个成分让你的护肤品效果翻倍」
4. 身份认同：「油皮姐妹一定要看完这条」
5. 数据背书：「月销100万+的精华到底值不值」
6. 场景共鸣：「上班迟到5分钟，我靠这个3分钟出门妆」

变量二：信息密度（内容主体）
在有限的时长内，信息密度决定了用户的完播率。核心原则是「每3秒一个新信息点」。我们为美妆内容设计的信息结构：
- 0-3秒：钩子
- 3-10秒：问题展示/痛点共鸣
- 10-25秒：解决方案/产品演示
- 25-35秒：效果对比/使用技巧
- 35-45秒：购买引导/互动引导

变量三：行动指令（结尾）
明确告诉用户下一步做什么。可以是关注、点赞、评论互动，也可以是点击购物车。关键原则是「一次只给一个指令」。`,
    coverImage:
      "https://readdy.ai/api/search-image?query=Beauty%20product%20photography%20setup%20with%20professional%20lighting%20and%20camera%20equipment%2C%20clean%20white%20background%2C%20cosmetics%20arranged%20artistically%2C%20modern%20studio%20aesthetic&width=800&height=450&seq=article-cover-06&orientation=landscape",
    date: "2026-05-08",
    readTime: "9分钟",
    tags: ["抖音", "美妆", "爆款公式", "短视频"],
    featured: false,
  },
  {
    id: "article-7",
    title: "小红书种草到转化的完整链路设计",
    slug: "xiaohongshu-seeding-conversion-funnel",
    category: "social-media",
    categoryName: "社交媒体运营",
    excerpt:
      "糖心传媒帮助某母婴品牌在小红书搭建的完整种草转化链路，从内容策略到效果度量的全流程实战分享。",
    content: `小红书已成为品牌种草营销的主阵地。但多数品牌面临的问题是：笔记数据好看，转化却不如预期。糖心传媒在服务多个品牌的过程中，总结出了一套从种草到转化的完整链路设计方法。

## 重新理解小红书的用户决策路径

小红书用户的典型决策路径：
发现笔记 → 深度阅读 → 搜索验证 → 收藏对比 → 决策购买

关键洞察：用户的购买决策不是在看完一篇笔记后立即做出的，而是在「搜索验证」和「收藏对比」环节完成的。因此，品牌在小红书的运营策略需要覆盖用户的完整决策链路，而非仅仅是发布种草笔记。

## 链路设计四步法

第一步：内容分层
我们将品牌内容分为四个层级：
- 认知层（20%）：品牌故事、行业科普，建立品牌认知
- 种草层（40%）：产品测评、使用教程，激发购买兴趣
- 信任层（25%）：用户真实反馈、专业背书，消除决策顾虑
- 转化层（15%）：促销信息、限时活动，推动最终下单

第二步：搜索占位
针对品牌核心关键词与品类词进行搜索占位，确保用户在「搜索验证」阶段能够看到品牌的正面内容。

第三步：评论区运营
将评论区作为「微型客服中心」和「信任建设阵地」，系统性地回复用户疑问，引导用户行为。

第四步：数据闭环
建立「内容表现→用户行为→销售转化」的数据追踪体系，实现从曝光到转化的全链路归因。`,
    coverImage:
      "https://readdy.ai/api/search-image?query=Minimalist%20workspace%20with%20laptop%20displaying%20social%20media%20dashboard%2C%20warm%20natural%20light%2C%20clean%20desk%20setup%2C%20professional%20yet%20cozy%20atmosphere%2C%20editorial%20style&width=800&height=450&seq=article-cover-07&orientation=landscape",
    date: "2026-04-22",
    readTime: "11分钟",
    tags: ["小红书", "种草", "转化链路", "内容策略"],
    featured: false,
  },
  {
    id: "article-8",
    title: "与头部KOL合作前，品牌必须做对的三件事",
    slug: "kol-cooperation-preparation-guide",
    category: "kol",
    categoryName: "KOL合作",
    excerpt:
      "基于糖心传媒200+次KOL合作实战经验，总结品牌在与头部KOL合作前必须完成的准备工作清单。",
    content: `头部KOL的合作费用动辄数十万甚至上百万，但很多品牌在合作后却发现效果远不如预期。问题往往不出在KOL身上，而是品牌自身的准备工作没有做到位。糖心传媒基于200+次KOL合作项目的复盘，总结了品牌在合作前必须做对的三件事。

## 第一件事：明确「一个核心目标」

很多品牌在KOL合作中同时追求曝光、种草、转化等多个目标，结果哪个都没做好。我们的建议是：每次KOL合作只设定一个核心目标，所有策略围绕这个目标展开。

- 如果目标是品牌曝光：选择粉丝量大的头部KOL，内容以品牌理念传达为主
- 如果目标是产品种草：选择垂类信任度高的中腰部KOL，内容以真实体验为核心
- 如果目标是直接转化：选择带货能力强的KOL，配合优惠机制与购买链路优化

## 第二件事：准备好「内容弹药库」

KOL是内容的创作者，但品牌需要提供充足的「弹药」支持。我们建议品牌为每次KOL合作准备：
- 产品核心卖点手册（3-5个差异化卖点）
- 品牌视觉素材包（高清产品图、品牌元素、场景模板）
- 竞品对比资料（合法合规的市场对比数据）
- 用户证言素材（真实用户的好评截图、使用效果对比）

## 第三件事：设计「转化承接体系」

KOL内容带来的流量必须有一个完整的承接体系。我们建议品牌在合作前完成：
- 电商承接页面优化（落地页、详情页、评论区）
- 搜索关键词布局（确保用户搜索时能看到品牌正面信息）
- 私域沉淀路径（如何将KOL粉丝转化为品牌私域用户）`,
    coverImage:
      "https://readdy.ai/api/search-image?query=Professional%20business%20meeting%20with%20creative%20team%20discussing%20marketing%20strategy%2C%20modern%20conference%20room%2C%20warm%20lighting%2C%20collaborative%20atmosphere%2C%20editorial%20photography&width=800&height=450&seq=article-cover-08&orientation=landscape",
    date: "2026-04-05",
    readTime: "7分钟",
    tags: ["KOL合作", "品牌营销", "合作准备", "实战经验"],
    featured: false,
  },
];

export const services = [
  {
    id: "svc-1",
    icon: "ri-movie-line",
    title: "短视频制作",
    description:
      "从创意策划到后期制作的全流程短视频服务。品牌故事、产品展示、创意广告，我们为每个品牌定制专属的视觉语言与内容风格。",
    features: ["创意策划", "拍摄制作", "后期剪辑", "特效包装"],
  },
  {
    id: "svc-2",
    icon: "ri-share-line",
    title: "社交媒体运营",
    description:
      "覆盖抖音、小红书、微信、微博、B站等主流平台的社交媒体矩阵运营，精细化内容策略与用户互动管理。",
    features: ["平台策略", "内容运营", "用户互动", "数据分析"],
  },
  {
    id: "svc-3",
    icon: "ri-user-star-line",
    title: "KOL合作",
    description:
      "覆盖美妆、时尚、美食、科技、母婴等20+垂直领域的优质KOL资源池，精准匹配品牌需求，实现高效种草。",
    features: ["KOL筛选", "内容共创", "效果追踪", "长期合作"],
  },
  {
    id: "svc-4",
    icon: "ri-lightbulb-line",
    title: "全案策划",
    description:
      "从品牌诊断、策略制定到创意执行的一站式品牌全案服务，帮助品牌建立完整的数字营销体系。",
    features: ["品牌诊断", "策略规划", "创意执行", "效果评估"],
  },
];

export const stats = [
  { value: "500+", label: "服务品牌", suffix: "" },
  { value: "3,200", label: "合作KOL", suffix: "+" },
  { value: "85", label: "客户满意度", suffix: "%" },
  { value: "150", label: "行业奖项", suffix: "+" },
];

export const processSteps = [
  {
    step: "01",
    title: "需求诊断",
    description: "深入沟通了解品牌现状、目标用户与核心诉求，输出品牌诊断报告",
  },
  {
    step: "02",
    title: "策略规划",
    description: "基于诊断结果制定定制化内容策略与执行方案，明确关键里程碑",
  },
  {
    step: "03",
    title: "创意执行",
    description: "专业团队落地创意内容制作，全程把控质量与品牌调性",
  },
  {
    step: "04",
    title: "数据优化",
    description: "实时监测内容表现数据，持续迭代优化策略，提升传播效果",
  },
  {
    step: "05",
    title: "复盘增长",
    description: "项目复盘与知识沉淀，助力品牌建立长期可持续的内容营销能力",
  },
];

export const partners = [
  "欧莱雅",
  "完美日记",
  "海底捞",
  "喜茶",
  "小米",
  "安踏",
  "花西子",
  "三只松鼠",
  "蔚来",
  "蕉下",
  "泡泡玛特",
  "元气森林",
];

export const testimonials = [
  {
    name: "张明远",
    title: "某新锐美妆品牌创始人",
    content:
      "与糖心传媒合作后，我们的抖音账号三个月粉丝从5万增长到80万，单月GMV突破千万。他们不仅懂内容，更懂品牌。",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20Chinese%20business%20portrait%20headshot%2C%20warm%20lighting%2C%20clean%20white%20background%2C%20confident%20expression%2C%20modern%20corporate%20style&width=100&height=100&seq=avatar-01&orientation=squarish",
  },
  {
    name: "李思涵",
    title: "某连锁餐饮品牌CMO",
    content:
      "从8家店到120+店，糖心传媒陪伴了我们最关键的品牌升级阶段。专业的全案能力和对餐饮行业的深刻理解让人印象深刻。",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20business%20portrait%2C%20warm%20lighting%2C%20clean%20white%20background%2C%20friendly%20professional%20expression%2C%20modern%20corporate%20style&width=100&height=100&seq=avatar-02&orientation=squarish",
  },
  {
    name: "王浩然",
    title: "某运动品牌市场总监",
    content:
      "糖心传媒的KOL深度共创模式帮我们实现了200%以上的ROI提升。他们对KOL的理解和把控能力在行业内是顶尖水平。",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20business%20headshot%2C%20warm%20lighting%2C%20clean%20white%20background%2C%20approachable%20expression%2C%20modern%20corporate%20style&width=100&height=100&seq=avatar-03&orientation=squarish",
  },
];